export default __webpack_public_path__ + "static/media/sp-protein-solved.b63f37a3.png";